import { FieldParsed } from 'utils/import/fieldMetadata/fieldConfig';
import { ValidationResult } from 'utils/import/validators/validator.model';

export function defaultValidator(value: FieldParsed): ValidationResult {
  return { isValid: true, value };
}
